export enum BoundaryCondition {
  FREE = 'free',
  PRESCRIBED = 'prescribed',
  RESTRAINED = 'restrained',
}
